import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

import { Autoplay } from "swiper";
// import required images
import img1 from "../../images/BrandsName/img1.avif";
import img2 from "../../images/BrandsName/img2.avif";
import img3 from "../../images/BrandsName/img3.avif";
import img4 from "../../images/BrandsName/img4.avif";
import img5 from "../../images/BrandsName/img5.webp";
import img6 from "../../images/BrandsName/img6.webp";
import img7 from "../../images/BrandsName/img7.webp";
import img8 from "../../images/BrandsName/img8.webp";
import img9 from "../../images/BrandsName/img9.webp";
const BrandsName = () => {
  return (
    <>
      <div className="Brands_name " style={{ paddingTop: "50px" }}>
        <div className="container-fluid">
          <Swiper
            slidesPerView={6}
            loop={true}
            breakpoints={{
              320: {
                slidesPerView: 2,
              },
              // when window width is >= 480px
              480: {
                slidesPerView: 2,
              },
              // when window width is >= 640px
              640: {
                slidesPerView: 4,
                spaceBetween: 120,
              },
              992: {
                slidesPerView: 6,
              },
            }}
            autoplay={{
              delay: 1900,
            }}
            modules={[Autoplay]}
            className="mySwiper pt-40"
          >
            <SwiperSlide>
              <img src={img1} alt="brandname"></img>
            </SwiperSlide>
            <SwiperSlide>
              <img src={img2} alt="brandname"></img>
            </SwiperSlide>
            <SwiperSlide>
              <img src={img3} alt="brandname"></img>
            </SwiperSlide>
            <SwiperSlide>
              <img src={img4} alt="brandname"></img>
            </SwiperSlide>
            <SwiperSlide>
              <img src={img5} alt="brandname"></img>
            </SwiperSlide>
            <SwiperSlide>
              <img src={img6} alt="brandname"></img>
            </SwiperSlide>
            <SwiperSlide>
              <img src={img7} alt="brandname"></img>
            </SwiperSlide>
            <SwiperSlide>
              <img src={img8} alt="brandname"></img>
            </SwiperSlide>
            <SwiperSlide>
              <img src={img9} alt="brandname"></img>
            </SwiperSlide>
            <SwiperSlide>
              <img src={img6} alt="brandname"></img>
            </SwiperSlide>
            <SwiperSlide>
              <img src={img4} alt="brandname"></img>
            </SwiperSlide>
            <SwiperSlide>
              <img src={img8} alt="brandname"></img>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </>
  );
};

export default BrandsName;
